export default "__VITE_ASSET__91874390__"